export default {
	preview: 'Avance',
	'production-order': 'orden de producción',
	'order-result': 'Orden De Trabajo',

	'production-order-created': 'Se crea la orden de producción',
	'production-order-updated': 'La orden de producción se actualiza',
	'order-result-created': 'Se crea el Orden De Trabajo',
	'order-result-updated': 'El Orden De Trabajo se actualiza',
	total: 'Total'
}